export default __webpack_public_path__ + "static/media/jhonathan-osorio-at-caq-soccer-24-of-43.8fa6090b.jpeg";